
window.VCA = window.VCA || {};

window.VCA.Tooltips = (function ($) {

    var ui = {};

    function init() {
        hightLightDay();
        initVCATooltip();
        initVCAPromoTooltip();

        $('html').on('click', function (e) {
            $('[data-toggle="popover"]').each(function () {
                   if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                    $(this).popover('hide');
                }
            });
        });
    }

    function hightLightDay() {
        var d = new Date();
        var day = new Date().toLocaleString('en-us', {  weekday: 'short' })
        $('div[data-day="' + day + '"').addClass('current-day');
    }

    function initVCATooltip() { 
        $('*[data-toggle="popover"]').each(function () {
            $(this).popover(
            {
                html: true,
                trigger: 'click',
                title: $('#' + $(this).data('target')).html(),
                template: '<div class="popover" role="tooltip"><div class="arrow"></div><div class="popover-header"></div></div>',
                placement: 'auto'
            });
        });
    }

     function initVCAPromoTooltip() { 
        $('*[data-toggle="popover-hover"]').each(function () {
            $(this).popover(
            {
                html: true,
                trigger: 'hover',
                title: $('#' + $(this).data('target')).html(),
                template: '<div class="promo-pill__tooltip tooltip" role="tooltip"><div class="arrow"></div><div class="popover-header tooltip-inner"></div></div>',
                placement: $(this).data('placement')
            });
        });
    } 


    return {
        init: init,
        initVCAPromoTooltip: initVCAPromoTooltip
    };

    

})(jQuery);

$(function () {
    window.VCA.Tooltips.init();
});

